let entryUrl: string | null = null;

const buildEntryUrl = (pathname: string, searchParamsString: string): string => {
  const queryString = searchParamsString.startsWith('?') ? searchParamsString.slice(1) : searchParamsString;
  return queryString ? `${pathname}?${queryString}` : pathname;
};

const readBrowserEntryUrl = (): string | null => {
  if (typeof window === 'undefined') return null;
  return buildEntryUrl(window.location.pathname, window.location.search);
};

export const captureEntryUrl = (): void => {
  if (entryUrl !== null) return;
  entryUrl = readBrowserEntryUrl();
};

export const isEntryUrl = (pathname: string, searchParamsString: string): boolean =>
  entryUrl !== null && entryUrl === buildEntryUrl(pathname, searchParamsString);

export const setEntryUrlForTests = (value: string | null): void => {
  entryUrl = value;
};
